import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";
import 'libphonenumber-js-utils/dist/libphonenumber.js';
import { toast } from 'react-toastify';
import {editDepartment} from "../../actions/actions";
import {connect} from "react-redux";
import Swal from 'sweetalert2';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class DepartmentEdit extends Component {

    constructor(props) {

        super(props);
        this.currentDepartment=this.props.chatprop.allDepartments.find(dep=>dep.id==this.props.chatprop.modal.data.id);
        this.state = {
            departmentName:this.currentDepartment.name,


        };
        this.updateDepartmentEvent=this.updateDepartmentEvent.bind(this);
        this.onChangeDepartmentName = this.onChangeDepartmentName.bind(this);
    }

    onChangeDepartmentName(e){
        this.setState({
            departmentName : e.target.value
        });
    }


    updateDepartmentEvent(e){

        if(this.state.departmentName.trim().length<1){
            toast.error("Check the department name.");
            return false;
        }


        var $updateData={
            department_name:this.state.departmentName,
            id:this.currentDepartment.id,
        };

        Swal.fire({
            title: 'Do you want to continue to update department ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(editDepartment($updateData));
            }
        });



    }


    render() {
        const { t } = this.props


        return (

            <>

                <Modal.Header closeButton>
                    <Modal.Title>Edit Department</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form method="post" className="validate-form editDepartment" encType="multipart/form-data">
                        <div className="form-group">
                            <label htmlFor="region-name">Department Name</label>
                            <div className="position-relative">
                                <input type="text"
                                       className="form-control form-control-lg"
                                       defaultValue={this.state.departmentName}
                                       onChange={this.onChangeDepartmentName.bind(this)}
                                       placeholder="Department Name" />

                            </div>
                        </div>

                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="chat-button chat-button-success ml-1 "
                            onClick={this.updateDepartmentEvent.bind(this)}
                    >
                        <span>Update, Save</span>
                    </button>
                </Modal.Footer>
            </>

        );
    }
}

export default withTranslation()(DepartmentEdit);
